import { GTBookingV2PaymentMethod } from 'gql/types.generated'
import { defineMessages } from 'react-intl'

export const paymentMethodMessages = defineMessages({
  [GTBookingV2PaymentMethod.Cash]: {
    id: 'dictionary.cash',
    defaultMessage: 'Cash'
  },
  [GTBookingV2PaymentMethod.Card]: {
    id: 'dictionary.card',
    defaultMessage: 'Card'
  },
  [GTBookingV2PaymentMethod.Coupon]: {
    id: 'dictionary.coupon',
    defaultMessage: 'Coupon'
  }
})
